import Template from './template';
import Util from './util';
import Lang from './lang';

import MasterData from './config/master-data';

let bill = {};

Template.add('bill-item',
    `<tr>
        <td>{{name}}</td>
        <td class="lt--text-right">{{amount}}</td>
        <td class="lt--text-right">{{pricePiece}}€</td>
        <td class="lt--text-right">{{priceTotal}}€</td>
    </tr>`);

Template.add('bill-sum',
    `
    <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
    <tr>
        <td></td>
        <td></td>
        <th class="lt--text-right">{{sumLabel}}</th>
        <td class="lt--text-right">{{sum}}€</td>
    </tr>`);

$(() => {
    render();

    $(document)
        .on('dd--removeel', (ev, dragging) => {
            if(!dragging.el.hasClass('dd--dragged')) return;
            remove(dragging.el.data('product-id'));
        })
        .on('ds--removeall', () => {
            remove();
        })
        .on('dd--dragend', (ev, dragging) => {
            if (ev.target === ev.currentTarget) return;  // filter bubbled events
            let $el = $(dragging.el);
            if (!$el.hasClass('dd--dragged')) add($el.data('product-id'));
        });
});

function get() {
    return bill;
}

function add(id) {
    if (!bill[id]) bill[id] = 0;
    bill[id]++;
    render();
}

function remove(id) {
    if (Util.isNull(id)) bill = {};
    else if (bill[id] && bill[id] > 0) {
        bill[id]--;
        if(bill[id] <= 0) delete bill[id];
    }
    render();
}

function render() {
    let sum = 0;
    let html = Object.keys(bill).reduce((html, prodId) => {
        let prod = MasterData.products[prodId];
        let amount = bill[prodId];
        if (!prod) return html;

        let pricePiece = prod.price,
            priceTotal = amount * pricePiece;
        sum += priceTotal;

        return html + Template.fill('bill-item', {
            amount,
            name: prod.name,
            pricePiece,
            priceTotal
        });
    }, '');

    html += Template.fill('bill-sum', {
        sumLabel: Lang.get('inventory.cart.sum'),
        sum,
    });

    $('#bill').html(html);
}

export default {
    add,
    remove,
    render,
    get
}
